import {Component} from '@angular/core';
import {Observable} from 'rxjs';
import {StrapiService} from '../../../services/strapi-service/strapi.service';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {ReleaseNotesHelp} from '../../../model/strapi/release-notes-help/release-notes-help';

@Component({
    selector: 'app-release-notes-help',
    templateUrl: './release-notes-help.component.html',
    styleUrls: ['../../../../styles/standard-elements.scss', '../../../pages/help/help.component.scss'],
    standalone: false
})
export class ReleaseNotesHelpComponent {

  releaseNotesHelps$: Observable<ReleaseNotesHelp[]> = this.strapiService.getReleaseNotesHelp();

  constructor(private readonly strapiService: StrapiService, private readonly sanitizer: DomSanitizer) {
  }

  getSafeVideoUrl(videoId: string): SafeResourceUrl {
    const url = `https://player.vimeo.com/video/${videoId}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  splitReleaseNotesStructured(notes: string): any[] {
    const lines = notes.split('\n').map(line => line.trim()).filter(Boolean);

    const structuredNotes = [];
    let currentMainItem = null;

    for (let line of lines) {
      if (line.startsWith('- ') && !line.startsWith('--- ')) {
        // New main item detected
        currentMainItem = { main: line.substring(2), subItems: [] };
        structuredNotes.push(currentMainItem);
      }
      // If line doesn’t start with "- ", assume it’s a description for the last main item
      else if (currentMainItem && !line.startsWith('- ')) {
        currentMainItem.subItems.push(line.substring(4));
      }
    }
    return structuredNotes;
  }

}
